import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TimeoutError } from 'rxjs/util/TimeoutError';
import 'rxjs/add/operator/timeout';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  protected Token = '';
  protected decodedToken: any;

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.Token = localStorage.getItem('Cardeal.Token');
    var posLoginRapido = localStorage.getItem('Login.Rapido') !== '1';
    if(this.Token && posLoginRapido){
      this.validaToken();
    }

    if (req.headers.has('meta')) {
      if (req.headers.get('meta') === 'upload') {
        return this.interceptUpload(req, next);
      }
      if (req.headers.get('meta') === 'upload2') {
        return this.interceptUpload2(req, next);
      }
      if (req.headers.get('meta') === 'search') {
        return this.interceptSearch(req, next);
      }
    }

    const contentType = req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json';
    const authReq = req.clone({
      setHeaders: {
        'Content-Type': contentType,
        'charset': 'utf-8',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Accept': contentType,
        'Authorization': `Bearer ${this.Token}`
      }
    });

    return next.handle(authReq);
  }

  private validaToken() {
    this.decodedToken = this.parseJwt(this.Token);
    const dataExpiracao = new Date((this.decodedToken.exp) * 1000);
    const dataAtual = new Date();

    if (dataAtual >= dataExpiracao) {
      localStorage.setItem('Login.Rapido', '1');
    }
  }

  parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }

  interceptUpload(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authReq = req.clone({
      setHeaders: {
        'charset': 'utf-8',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Authorization': `Bearer ${this.Token}`
      }
    });

    return next.handle(authReq);
  }

  interceptUpload2(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authReq = req.clone({
      setHeaders: {
        'charset': 'utf-8',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
      }
    });

    return next.handle(authReq);
  }

  interceptSearch(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const defaultTimeout = 15000;

    this.Token = localStorage.getItem('Cardeal.Token');
    const contentType = req.headers.has('Content-Type') ? req.headers.get('Content-Type') : 'application/json';
    const authReq = req.clone({
      setHeaders: {
        'Content-Type': contentType,
        'charset': 'utf-8',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Accept': contentType,
        'Authorization': `Bearer ${this.Token}`
      }
    });

    // const timeout = Number(req.headers.get('timeout')) || defaultTimeout;
    return next.handle(authReq).timeout(defaultTimeout);
  }

}
